<div class="row" id="subnav">
  <div class="col">
    @if (marketList) {
      <span class="float-left">
        <span class="fas fa-map-marker-alt"></span>
        @if (marketList?.length > 1) {
          <select #mkt [ngModel]="market ? market.sourceKey : null" (change)="selectedMarketChanged(mkt.value)">
            @for (market of marketList; track market) {
              <option [value]="market.sourceKey">{{market.orgName}} {{market.sourceKey}}</option>
            }
          </select>
        }
        @if (marketList?.length === 1) {
          <span>{{market.orgName}} {{market.sourceKey}}</span>
        }
      </span>
    }
    <span class="float-right">
      @if (displayName) {
        <span class="bell-icon mr-3"
              (click)="openNotificationSidebar()">
          <i class="fas fa-bell"></i>
          @if (userHasNotices()) {
          <i severity="danger" pBadge></i>
          }
        </span>
      }
      <a [href]="constructionPortalHelpUrl"
         target="_blank"
         rel="noopener noreferrer"
         class="mr-3 text-reset"
         aria-label="Construction Portal help">
        <i class="fa-regular fa-circle-question"></i>
      </a>
      @if (displayName) {
        <a routerLink="/profile" class="d-inline d-sm-none" aria-label="Profile">
          <i class="fas fa-user"></i>
        </a>
        <span class="d-none d-sm-inline">
          <i class="fas fa-user"></i> <a routerLink="/profile">{{displayName}}</a>
        </span>
      }
    </span>
  </div>
</div>
